var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsiaexpoVenueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 881,
    height: 390,
    viewBox: "0 0 881 390",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.4692 335.738L66.0892 387.35C65.6905 388.146 65.0924 388.781 64.295 389.254C63.5226 389.751 62.6628 390 61.7159 390C60.7939 390 59.9342 389.751 59.1368 389.254C58.3643 388.781 57.7663 388.146 57.3426 387.35L32 335.738H42.8771L61.7159 374.289L80.6295 335.738H91.4692Z",
    fill: "url(#paint0_linear_1584_378)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141.033 367.385H110.345V357.607H141.033V367.385ZM145.406 389.254H110.345C109 389.254 107.53 389.017 105.935 388.545C104.34 388.072 102.857 387.301 101.487 386.231C100.141 385.136 99.0072 383.73 98.0852 382.014C97.1881 380.272 96.7396 378.145 96.7396 375.632V340.627C96.7396 339.955 96.8642 339.321 97.1134 338.724C97.3626 338.127 97.699 337.604 98.1226 337.156C98.5711 336.709 99.0944 336.36 99.6925 336.111C100.291 335.863 100.938 335.738 101.636 335.738H145.406V345.441H106.458V375.632C106.458 376.901 106.794 377.871 107.467 378.543C108.14 379.215 109.124 379.551 110.42 379.551H145.406V389.254Z",
    fill: "url(#paint1_linear_1584_378)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M208.389 385.111C208.389 385.808 208.252 386.455 207.978 387.052C207.729 387.649 207.38 388.171 206.931 388.619C206.508 389.042 205.997 389.378 205.399 389.627C204.801 389.876 204.165 390 203.493 390C202.895 390 202.284 389.888 201.661 389.664C201.063 389.44 200.527 389.079 200.054 388.582L164.544 351.561V389.254H154.826V339.881C154.826 338.885 155.1 337.99 155.648 337.194C156.221 336.373 156.944 335.763 157.816 335.365C158.738 334.992 159.685 334.905 160.657 335.104C161.629 335.278 162.464 335.726 163.161 336.447L198.671 373.43V335.738H208.389V385.111Z",
    fill: "url(#paint2_linear_1584_378)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M272.232 384.365C272.232 385.061 272.107 385.708 271.858 386.305C271.609 386.903 271.26 387.425 270.811 387.873C270.363 388.296 269.84 388.632 269.241 388.88C268.643 389.129 268.008 389.254 267.335 389.254H245.431C243.363 389.254 241.27 389.03 239.152 388.582C237.034 388.134 234.978 387.45 232.984 386.529C231.016 385.584 229.159 384.39 227.415 382.947C225.671 381.504 224.138 379.799 222.817 377.834C221.522 375.844 220.5 373.58 219.752 371.042C219.005 368.479 218.631 365.631 218.631 362.496V335.738H228.349V362.496C228.349 365.233 228.723 367.546 229.471 369.437C230.243 371.328 231.215 372.908 232.386 374.177C233.557 375.446 234.841 376.441 236.236 377.162C237.632 377.884 238.952 378.419 240.198 378.767C241.469 379.115 242.578 379.339 243.525 379.439C244.497 379.513 245.132 379.551 245.431 379.551H262.513V335.738H272.232V384.365Z",
    fill: "url(#paint3_linear_1584_378)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M327.627 367.385H296.939V357.607H327.627V367.385ZM332 389.254H296.939C295.593 389.254 294.123 389.017 292.528 388.545C290.933 388.072 289.451 387.301 288.08 386.231C286.735 385.136 285.601 383.73 284.679 382.014C283.782 380.272 283.333 378.145 283.333 375.632V340.627C283.333 339.955 283.458 339.321 283.707 338.724C283.956 338.127 284.293 337.604 284.716 337.156C285.165 336.709 285.688 336.36 286.286 336.111C286.884 335.863 287.532 335.738 288.23 335.738H332V345.441H293.052V375.632C293.052 376.901 293.388 377.871 294.061 378.543C294.734 379.215 295.718 379.551 297.014 379.551H332V389.254Z",
    fill: "url(#paint4_linear_1584_378)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M484.153 134.11L475.837 107.323H427.29L417.948 134.11H388.889L435.812 4.27979H467.709L514.068 134.11H484.153ZM451.461 33.4338H451.282L434.444 85.0409H467.923L451.461 33.4338Z",
    fill: "#EC1C24"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M603.419 42.6218C602.752 35.9722 600.308 31.0206 596.085 27.767C591.863 24.5135 585.524 22.8838 577.068 22.8781C561.479 22.8781 553.687 28.1545 553.692 38.7073C553.686 40.5613 554.123 42.39 554.967 44.0405C555.812 45.691 557.039 47.1154 558.547 48.1945C561.778 50.7301 566.96 52.8469 574.094 54.545C582.55 56.4994 589.88 58.3228 596.085 60.0151C601.893 61.5796 607.587 63.5386 613.128 65.8784C616.023 67.0487 618.785 68.5242 621.367 70.2801C623.936 72.0355 626.154 74.2561 627.906 76.8271C629.817 79.7163 631.259 82.8894 632.179 86.2289C633.322 90.5641 633.854 95.0374 633.761 99.5196C633.876 105.304 632.514 111.023 629.803 116.135C627.172 120.942 623.519 125.114 619.102 128.357C614.316 131.822 608.95 134.403 603.256 135.981C597.006 137.763 590.534 138.649 584.034 138.614C564.878 138.614 550.482 134.967 540.846 127.674C531.211 120.38 526.125 109.554 525.59 95.1948H552.137C552.109 98.2912 552.845 101.347 554.279 104.091C555.713 106.836 557.801 109.184 560.359 110.93C565.709 114.776 572.413 116.699 580.47 116.699C589.188 116.699 595.792 115.135 600.282 112.007C602.397 110.643 604.128 108.759 605.307 106.535C606.486 104.311 607.075 101.822 607.017 99.3059C607.036 97.3543 606.768 95.4105 606.222 93.5366C605.642 91.6951 604.583 90.0405 603.154 88.7417C601.314 87.1143 599.202 85.8239 596.914 84.9297C593.577 83.6197 590.131 82.6072 586.615 81.9041C576.576 79.8186 567.889 77.7018 560.556 75.5536C553.222 73.4055 547.168 70.7302 542.393 67.5279C537.925 64.6495 534.303 60.6349 531.898 55.8954C529.647 51.337 528.524 45.5392 528.53 38.5021C528.495 33.3357 529.507 28.2156 531.504 23.4508C533.519 18.7061 536.644 14.5145 540.615 11.2285C545.104 7.56053 550.246 4.77374 555.769 3.01476C561.781 1.00905 568.88 0.00619301 577.068 0.00619301C584.304 -0.0898041 591.511 0.930745 598.436 3.03185C604.379 4.84525 609.927 7.76544 614.786 11.6387C619.286 15.2829 622.908 19.8924 625.384 25.126C627.94 30.6163 629.353 36.5687 629.538 42.6218H603.419Z",
    fill: "#EC1C24"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M655.324 134.11V4.27979H682.905V134.11H655.324Z",
    fill: "#EC1C24"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M798.955 134.11L790.596 107.323H742.092L732.784 134.11H703.656L750.613 4.27979H782.511L828.87 134.11H798.955ZM766.263 33.4338H766.066L749.229 85.0409H782.707L766.263 33.4338Z",
    fill: "#EC1C24"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M392.82 288.513V158.709H489.504V181.384H419.572V209.145H483.957V232.017H419.572V265.444H492.675V288.521L392.82 288.513Z",
    fill: "#231F20"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M589.153 288.513L563.99 243.94L537.444 288.513H505.35L547.948 222.23L507.691 158.709H540.17L563.939 200.743L587.871 158.709H619.768L579.751 221.102L622.537 288.547L589.153 288.513Z",
    fill: "#231F20"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M639.871 288.513V158.709H697.922C703.9 158.609 709.837 159.707 715.384 161.939C720.374 163.991 724.883 167.059 728.623 170.948C732.336 174.795 735.242 179.346 737.17 184.333C739.182 189.574 740.191 195.146 740.144 200.76C740.192 206.349 739.174 211.895 737.144 217.102C735.258 221.969 732.342 226.372 728.597 230.008C724.794 233.647 720.301 236.49 715.384 238.367C709.817 240.466 703.905 241.496 697.956 241.401H667.444V288.513H639.871ZM693.563 219.282C701.483 219.282 707.181 217.49 710.657 213.906C714.133 210.321 715.882 205.663 715.905 199.931C715.905 194.461 714.156 189.965 710.657 186.444C707.159 182.922 701.461 181.162 693.563 181.162H667.409V219.282H693.563Z",
    fill: "#231F20"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M818.169 293C797.838 293 782.22 287.137 771.314 275.41C760.408 263.684 754.961 246.812 754.972 224.794C754.834 214.798 756.238 204.841 759.135 195.273C761.597 187.074 765.785 179.497 771.417 173.051C776.866 166.964 783.646 162.217 791.229 159.179C799.023 155.982 808.003 154.384 818.169 154.384C828.214 154.384 837.163 155.982 845.015 159.179C852.615 162.184 859.379 166.977 864.733 173.153C870.251 179.709 874.364 187.328 876.818 195.538C879.587 204.336 880.972 214.27 880.972 225.341C880.972 247.758 875.59 264.635 864.827 275.974C854.063 287.313 838.511 292.989 818.169 293ZM818.169 269.743C822.92 269.77 827.631 268.873 832.04 267.102C836.404 265.341 840.302 262.597 843.434 259.085C846.909 255.075 849.506 250.382 851.057 245.307C852.909 239.706 853.835 233.059 853.835 225.367C853.835 209.982 850.798 198.319 844.724 190.375C838.65 182.432 829.798 178.458 818.169 178.452C806.545 178.452 797.63 182.427 791.425 190.375C785.22 198.324 782.117 209.988 782.117 225.367C782.117 240.752 785.251 251.991 791.519 259.085C797.787 266.179 806.67 269.732 818.169 269.743Z",
    fill: "#231F20"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M327.127 37.6644V3.06592H244.854L231.828 37.6644H327.127Z",
    fill: "url(#paint5_linear_1584_378)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M150.615 253.409L137.59 288.008H330.427V253.409H150.615Z",
    fill: "url(#paint6_linear_1584_378)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M310.222 120.298H200.727L187.701 154.897H310.222V120.298Z",
    fill: "url(#paint7_linear_1584_378)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2649 3.06592L64.7776 66.5705H191.453L214.965 3.06592H256.222L148.931 288.042H107.692L0 3.06592H41.2649ZM179.059 101.169H77.5639L128.307 238.777L179.059 101.169Z",
    fill: "#231F20"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M214.94 3.06592L107.684 288.008H148.931L256.196 3.06592H214.94Z",
    fill: "#EC1C24"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1584_378",
    x1: 32.1854,
    y1: 361.739,
    x2: 336.859,
    y2: 361.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E2B38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#453C62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1584_378",
    x1: 32.1854,
    y1: 361.739,
    x2: 336.859,
    y2: 361.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E2B38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#453C62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1584_378",
    x1: 32.1854,
    y1: 361.739,
    x2: 336.859,
    y2: 361.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E2B38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#453C62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1584_378",
    x1: 32.1854,
    y1: 361.739,
    x2: 336.859,
    y2: 361.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E2B38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#453C62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1584_378",
    x1: 32.1854,
    y1: 361.739,
    x2: 336.859,
    y2: 361.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E2B38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#453C62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1584_378",
    x1: 231.828,
    y1: 20.3652,
    x2: 327.127,
    y2: 20.3652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1584_378",
    x1: 137.59,
    y1: 270.708,
    x2: 330.427,
    y2: 270.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1584_378",
    x1: 187.701,
    y1: 137.598,
    x2: 310.222,
    y2: 137.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsiaexpoVenueIcon);
export default __webpack_public_path__ + "static/media/asiaexpo-venue-icon.3e478fce5306fd7261755d1f5768b50e.svg";
export { ForwardRef as ReactComponent };